import type { ProgressBarProps } from 'react-aria-components';
import { ProgressBar } from 'react-aria-components';

export function LoadingIndicator(
  { size = 24, strokeWidth = 2, ...props }:
    { size?: number; strokeWidth?: number } & ProgressBarProps,
) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDasharray = `${circumference * 0.25} ${circumference * 0.75}`;

  return (
    <ProgressBar aria-label="Loading…" {...props}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="animate-spin"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={strokeDasharray}
          stroke="currentColor"
          fill="none"
        />
      </svg>
    </ProgressBar>
  );
}
